module.exports = __webpack_public_path__ + "static/media/schneider.750d7d86.svg";